export const USER_CHECKS_KEY = 'user-checks';
